<template>
  <div class="video-full-area">
    <div :class="getVideoContainterClass()">
      <div v-show="!videoEnded || noEndingMessage">
        <!-- Super cool component I found for youtube videos: https://www.npmjs.com/package/vue-youtube-embed -->
        <youtube v-if="isYouTube()" class="video-content" :video-id="url" :player-width="width" :player-height="height" @playing="onVideoStarted()" @ended="onVideoEnded()" @ready="onVideoReady" @paused="onVideoPaused()" controls playsinline>
          {{ errorVideo }}
        </youtube>
        <div v-if="!isYouTube()" class="jwplayer-wrapper">
          <!-- player jwplayer -->
          <div :id="id"></div>
        </div>
      </div>
      <div v-show="videoEnded && !noEndingMessage" class="message-after-video" :style="getMessageAfterStyle()">
        <p v-html="getMessage()"></p>
        <button class="replay-btn" @click="replayVideo()"><font-awesome-icon title="Rejouer la vidéo" icon="redo" /></button>
      </div>
    </div>
    <div v-if="doesVideoTranscriptExist()">
      <div class="accordion pb-5 flex-grow-1" :id="getAccordianId()">
        <div :class="getFolderAccordianContainer()" :style="getAccordianWidthBasedOnVideo()">
          <div class="folder-accordian">
            <div class="mb-0 row">
              <button class="btn btn-link col float-left folder-label" v-b-toggle="'coll-' + id">{{ transcriptTitle }} <font-awesome-icon class="float-right" icon="caret-down" /></button>
            </div>
          </div>
          <b-collapse :id="'coll-' + id">
            <div class="playlist-transcript">
              <span style="white-space: pre-line" v-html="displayTranscript()"></span>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    mediaId: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "id-video-player",
    },
    url: {
      type: String,
      default: "R8Q7VC3z3LA", // (5 second countdown) ->  "Ce5NbGDIWmE"  (Placeholder)
    },
    track: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "video",
    },
    transcription: {
      type: String,
      default: "",
    },
    poster: {
      type: String,
      default: "",
    },
    percent: {
      type: String,
      default: "100",
    },
    center: {
      type: String,
      default: "yes",
    },
    youtube: {
      type: String,
      default: "yes",
    },
    width: {
      type: String,
      default: "480",
    },
    height: {
      type: String,
      default: "270",
    },
    minheight: {
      type: String,
      default: "270",
    },
    message: {
      type: String,
      default: "HP_paragraph4",
    },
    noEndingMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Text
      errorVideo: "Votre navigateur ne prend pas en charge la balise <video>.",

      // Images

      // Variables
      transcript: null,
      transcriptTitle: this.LG("G_transcriptionLabel"),
      youtubePlayer: null,
      isPlaying: false,
      videoEnded: false,

      JwPlayerInstance: null,
    };
  },
  mounted() {
    if (!this.isYouTube() && this.mediaId != "") {
      this.setJwPlayer(this.mediaId);
    }

    if (!this.isYouTube()) {
      this.registerVideoStateListeners();
    }

    // This is how we pass in a transcription
    if (this.transcription != null && this.transcription != "") {
      this.transcript = this.transcription;
    }
  },
  computed: {},
  methods: {
    replayVideo() {
      this.videoEnded = false;

      this.$nextTick(() => {
        if (this.youtubePlayer) {
          this.youtubePlayer.playVideo();
        }
        if (this.JwPlayerInstance) {
          this.JwPlayerInstance.play();
        }
      });
    },
    setJwPlayer(mediaId) {
      this.JwPlayerInstance = window
        .jwplayer(this.id)
        .setup({
          playlist: "https://cdn.jwplayer.com/v2/media/" + mediaId,
        })
        .setCaptions({
          fontSize: 18,
        });
      try {
        this.JwPlayerInstance.setCurrentCaptions(1);
      } catch (error) {
        console.log(error);
      }
    },
    getMessage() {
      return this.LG(this.message);
    },
    getFolderAccordianContainer() {
      if (this.center == "no") {
        return "card mb-2 rounded border-bottom folder-accordian-container-left";
      } else {
        return "card mb-2 rounded border-bottom folder-accordian-container";
      }
    },
    getMessageAfterStyle() {
      var style = "width: 86%; height: " + this.height + "px; min-height: " + this.minheight + "px;";
      if (this.isYouTube()) {
        style = "width: 82%; height: " + this.height + "px; min-height: " + this.minheight + "px;";
      }
      return style;
    },
    getAccordianWidthBasedOnVideo() {
      var style = "width: 86%; padding-top: 3px;";
      if (this.isYouTube()) {
        style = "width: 82%; padding-top: 3px;";
      }
      return style;
    },
    getCollapseId() {
      return "coll-" + this.id;
    },
    getAccordianId() {
      return "acc-" + this.id;
    },
    getWidthPercent() {
      return this.width + "%";
    },
    getHeightPercent() {
      return this.height + "%";
    },
    getVideoContainterClass() {
      if (this.center == "yes") {
        return "video-container";
      } else {
        return "video-container-left";
      }
    },
    registerVideoStateListeners() {
      // We'll listen for every time the video plays, pauses or ends
      if (this.JwPlayerInstance) {
        this.JwPlayerInstance.on("play", this.onVideoStarted);
        this.JwPlayerInstance.on("complete", this.onVideoEnded);
        this.JwPlayerInstance.on("pause", this.onVideoPaused);
      }
    },

    setMute(muted) {
      if (this.youtubePlayer) {
        if (muted) {
          this.youtubePlayer.mute();
        } else {
          this.youtubePlayer.unMute();
        }
      }
      if (this.JwPlayerInstance) {
        // set Mute to true or false
        this.JwPlayerInstance.setMute(muted);
      }
    },
    onVideoStarted() {
      this.$emit("video-started", this.id);
      //console.log("onVideoStarted: " + this.id);

      // Mute all audio (not video)
      this.setAllVolume(0, true, false);
      this.isPlaying = true;
      this.videoEnded = false;
    },
    onVideoEnded() {
      this.$emit("video-ended", this.id);
      // console.log("onVideoEnded: " + this.id);

      this.isPlaying = false;
      this.videoEnded = true;

      // Unmute all audio which we had muted while playing the video
      if (this.$store.state.gamestate.muted == false) {
        this.setAllVolume(1, true, false);
      }
    },
    onVideoReady(event) {
      this.$emit("video-ready", this.id);
      this.youtubePlayer = event.target;

      this.isPlaying = false;
    },
    onVideoPaused() {
      this.$emit("video-paused", this.id);
      //console.log("onVideoPaused: " + this.id);

      this.isPlaying = false;

      // Unmute all audio which we had muted while playing the video
      if (this.$store.state.gamestate.muted == false) {
        this.setAllVolume(1, true, false);
      }
    },

    StopVideo() {
      this.isPlaying = false;

      // Unmute all audio which we had muted while playing the video
      if (this.$store.state.gamestate.muted == false) {
        this.setAllVolume(1, true, false);
      }

      if (this.youtubePlayer) {
        this.youtubePlayer.stopVideo();
      }

      if (this.JwPlayerInstance) {
        this.JwPlayerInstance.stop();
      }
    },

    isYouTube() {
      if (this.youtube == "yes") {
        return true;
      }
      return false;
    },
    PlayVideo(mediaId, transcriptFilename) {
      if (mediaId != "") {
        this.setJwPlayer(mediaId);
      }

      if (transcriptFilename != null) {
        this.transcript = transcriptFilename;
      }
    },
    doesVideoTranscriptExist() {
      var url = this.transcript;

      if (url == null || url.length == 0 || url == "") {
        return false;
      }
      var http = new XMLHttpRequest();
      http.open("HEAD", url, false);
      http.send();
      if (http.status === 200) {
        return true;
      }
      return false;
    },
    displayTranscript() {
      // Another way to do this could be:  (TBD)
      //<object :data="this.descriptions"></object>

      var file = this.transcript;
      var allText = "-----";
      if (file == null || file == "") {
        return allText;
      }
      var rawFile = new XMLHttpRequest();
      rawFile.open("GET", file, false);
      rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            allText = rawFile.responseText;
          }
        }
      };
      rawFile.send(null);
      return allText;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jwplayer-wrapper {
  width: 85%;
  margin-left: auto;
  margin-right: auto;
}
video::cue {
  font-size: 1.1rem;
}
#coll-id-video-player {
  font-size: 1rem !important;
}
</style>
<style>
.jw-slider-volume {
  background: #262626 !important;
}

.jw-state-idle .jw-controls,
.jwplayer.jw-state-complete .jw-controls {
  background: rgba(0, 0, 0, 0.5) !important;
}
.replay-btn {
  position: absolute;
  bottom: 15px;
  right: 15px;
  border: none;
  background-color: transparent;
  color: #fff;
  border: solid 1px white;
  border-radius: 10px;
  padding: 5px 15px;
}
.video-container-left {
  text-align: left !important;
  margin-left: 15px;
}

.video-container {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  overflow: auto;
}

.video-content {
  display: block;
  width: 85%;
  height: 85%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.video-full-area {
}

.folder-accordian-container-left {
  display: block;
  margin-left: 15px;
  margin-right: auto;
  background-color: transparent;
}

.folder-accordian-container {
  display: block;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent;
}

.folder-accordian {
  background-color: white;
  border: 2px solid black;
  text-align: center;
  margin-top: 0px;
}

.folder-label {
  color: black;
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: bold;
  font-size: 17px;
}

.playlist-transcript {
  margin-right: 2px;
  margin-left: 2px;
  max-height: 300px;
  overflow: auto;
  text-align: left;
  padding: 12px;
  background-color: white;
}

.message-after-video {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 25px;
  background-color: #07415b;
  text-align: center;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
</style>
